import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './style.scoped.scss';

const PhoneNumberInput = ({
  phoneValue,
  onChangeNumber,
  errorMessage,
  disabled,
  showError,
  handleNumberBlur,
  handleNumberFocus,
  showPlaceholder = true,
  placeholderValue = 'Enter phone number'
}) => {
  return (
    <div className='d-flex flex-column'>
      <PhoneInput
        placeholder={showPlaceholder ? placeholderValue : ''}
        // defaultCountry='AU'
        international
        value={phoneValue}
        onChange={onChangeNumber}
        className='phoneInput'
        disabled={disabled}
        onBlur={handleNumberBlur}
        onFocus={handleNumberFocus}
      />
      {showError && (
        <span style={{ color: '#dc3545' }}>
          <b>{errorMessage}</b>
        </span>
      )}
    </div>
  );
};

export default PhoneNumberInput;
